import * as React from "react";
import Timer from "otp-timer"
import {OTPTimmer} from "styles/components/OtpTimer";
import { useText } from "locales/useGetText";

const OtpTimmer = (props) => {
const locale = useText("commonModals");

const handleClick=()=>{
    props?.callBack()
}
 return (
    <OTPTimmer>
        <Timer seconds= {60} minutes={0} text={locale("timeLeft")} ButtonText={props?.btnTxt} resend={handleClick} />
    </OTPTimmer>
  );
};

export default OtpTimmer;
